const namespace = 'channel-picker-select-channel';
export default namespace;
